import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Container,
  Spinner,
} from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { toast } from "react-toastify";
import { getRecords, saveRecords } from "../../../services/api.service";
import SelectInput from "../../../custom/components/Select-Input/SelectInput";
import CheckboxInput from "../../../custom/components/CheckBox-Input/CheckboxInput";
import { useLocation, useNavigate } from "react-router-dom";

const UserTypeAccess = () => {
  const [selectedUserRole, setSelectedUserRole] = useState(null);
  const [roleSelectOptions, setRoleSelectOptions] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userRoleError, setUserRoleError] = useState(false);
  useEffect(() => {
    getRoleData();
  }, []);
  const getRoleData = async () => {
    const schema = localStorage.getItem("schema");
    try {
      let payload = {
        modelName: "role_masters",
        whereCondition: {
          is_active: true,
        },
        schema: schema,
        orderBy: {
          field: "role_name",
          order: "asc",
        },
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map((item) => ({
        value: item.id,
        label: item.role_name,
      }));
      setRoleSelectOptions(newArray);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleUserRoleSelectChange = (options) => {
    const selectedValue = options ? options.value : "";

    setSelectedUserRole(options);
    setUserRoleError(false);
    setData([]);
  };

  const handleGo = async () => {
    if (!selectedUserRole) {
      setUserRoleError(true);
      return;
    }

    const schema = localStorage.getItem("schema");

    const payload = {
      modelName: "menu_masters",
      schema,
      whereCondition: {
        is_active: true,
      },
      pagination: { page: 1, pageSize: 1000000 },
      relations: [
        {
          module: "menu_access_masters",
          moduleAs: "menu_access",
          isModuleWhereConditionRequired: true,
        },
      ],
      moduleWhereCondition: {
        role_id: selectedUserRole?.value,
        is_active: true,
      },
    };

    try {
      setLoading(true);

      const responseData = await getRecords(payload, "/getRecords");

      if (responseData?.data?.length > 0) {
        const rawData = responseData.data.map((item) => {
          const hasAccess = item?.menu_access?.some(
            (access) => access?.access === true
          );

          return {
            ...item,
            isChecked: hasAccess,
            isIndeterminate: false,
            isExpanded: false,
            primary_id: item?.menu_access?.[0]?.id ?? null,
          };
        });

        var updatedData = rawData.map((parent) => {
          if (parent.parent_id !== null) return parent;

          const children = rawData.filter(
            (child) => child.parent_id === parent.id
          );

          if (children.length === 0) return parent;

          const checkedCount = children.filter((c) => c.isChecked).length;

          if (checkedCount === 0) {
            return {
              ...parent,
              isChecked: false,
              isIndeterminate: false,
            };
          }

          if (checkedCount === children.length) {
            return {
              ...parent,
              isChecked: true,
              isIndeterminate: false,
            };
          }

          return {
            ...parent,
            isChecked: false,
            isIndeterminate: true, // ⭐ PARTIAL
          };
        });

        const getPriority = (item) => {
          if (item.isChecked) return 1; // highest
          if (item.isIndeterminate) return 2; // second
          return 3; // last
        };

        updatedData = [...updatedData].sort(
          (a, b) => getPriority(a) - getPriority(b)
        );

        setData(updatedData);
      } else {
        setData([]);
        toast.info("No menu found for the selected user role.");
      }
    } catch (error) {
      console.error("Error fetching menus:", error);
      toast.error("Failed to load menu access.");
    } finally {
      setLoading(false);
    }
  };

  const handleToggleExpand = (id) => {
    setData((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, isExpanded: !item.isExpanded } : item
      )
    );
  };

  // const handleCheckboxChange = (menuId, checked) => {
  //   const updated = data.map((item) => {
  //     // Parent toggled → toggle children
  //     if (item.id === menuId) {
  //       return { ...item, isChecked: checked };
  //     }

  //     if (item.parent_id === menuId) {
  //       return { ...item, isChecked: checked };
  //     }

  //     return item;
  //   });

  //   setData(updated);
  // };

  const handleCheckboxChange = (menuId, checked) => {
    setData((prev) => {
      let updated = [...prev];

      const clickedItem = updated.find((i) => i.id === menuId);

      // 1️⃣ Toggle clicked item
      updated = updated.map((item) =>
        item.id === menuId
          ? { ...item, isChecked: checked, isIndeterminate: false }
          : item
      );

      // 2️⃣ If PARENT → toggle all children
      if (clickedItem?.parent_id === null) {
        updated = updated.map((item) =>
          item.parent_id === menuId ? { ...item, isChecked: checked } : item
        );
      }

      // 3️⃣ If CHILD → update parent state
      if (clickedItem?.parent_id !== null) {
        const parentId = clickedItem.parent_id;

        const children = updated.filter((item) => item.parent_id === parentId);

        const checkedCount = children.filter((c) => c.isChecked).length;

        updated = updated.map((item) => {
          if (item.id !== parentId) return item;

          if (checkedCount === 0) {
            return {
              ...item,
              isChecked: false,
              isIndeterminate: false,
            };
          }

          if (checkedCount === children.length) {
            return {
              ...item,
              isChecked: true,
              isIndeterminate: false,
            };
          }

          return {
            ...item,
            isChecked: false,
            isIndeterminate: true, // ⭐ PARTIAL
          };
        });
      }

      return updated;
    });
  };
  const navigate = useNavigate();
  const location = useLocation();
  const getFirstAccessibleMenu = (menus) => {
    // 1️⃣ Try parent menus with real URLs
    const parentMenu = menus
      .filter(
        (item) =>
          item.isChecked === true &&
          item.parent_id === null &&
          item.menu_url &&
          item.menu_url !== "#" &&
          item.menu_url !== ""
      )
      .sort((a, b) => (a.sequence ?? 0) - (b.sequence ?? 0))[0];

    if (parentMenu) return parentMenu;

    // 2️⃣ Fallback → child menus
    const childMenu = menus
      .filter(
        (item) =>
          item.isChecked === true &&
          item.parent_id !== null &&
          item.menu_url &&
          item.menu_url !== "#" &&
          item.menu_url !== ""
      )
      .sort((a, b) => (a.sequence ?? 0) - (b.sequence ?? 0))[0];

    return childMenu || null;
  };

  const handleSubmit = async () => {
    if (!selectedUserRole) {
      toast.error("Please select user Role.");
      return;
    }
    const checkedUsers = data
      .filter((user) => user.isChecked)
      .map((user) => user.id);
    if (checkedUsers.length === 0) {
      toast.error("Please select at least one menu.");
      return;
    }
    setLoading(true);
    const payload = {
      modelName: "menu_access_masters",
      inputData: data.map((item) => ({
        id: item.primary_id,
        role_id: selectedUserRole?.value,
        menu_id: item.id,
        access: item.isChecked ?? false,
        is_active: true,
      })),
    };

    try {
      const response = await saveRecords(payload, "/saveRecords");

      if (response.code === 1) {
        toast.success("Access successfully updated.");

        const currentPath = location.pathname;

        const hasCurrentPageAccess = data.some(
          (item) => item.menu_url === currentPath && item.isChecked === true
        );

        if (!hasCurrentPageAccess) {
          const firstMenu = getFirstAccessibleMenu(data);
          localStorage.setItem("menusUpdatedAt", Date.now());

          if (firstMenu?.menu_url) {
            navigate(firstMenu.menu_url, { replace: true });
          } else {
            navigate("/no-access", { replace: true });
          }
        } else {
          navigate(0);
        }
      } else {
        toast.error("Failed to update access.");
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An error occurred while submitting data.");
    } finally {
      setLoading(false);
    }
  };
  // Check if all menus are selected
  const isAllSelected = data.length > 0 && data.every((item) => item.isChecked);

  // Handle select / unselect all
  const handleSelectAll = (checked) => {
    const updated = data.map((item) => ({
      ...item,
      isChecked: checked,
    }));

    setData(updated);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="USER ROLE ACCESS" breadcrumbItems={[]} />
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Row className="justify-content-center ">
                      <Col md={4}>
                        <SelectInput
                          label="User Role"
                          value={selectedUserRole}
                          onSelect={handleUserRoleSelectChange}
                          options={roleSelectOptions}
                          classNamePrefix="select2-selection"
                          noOptionsMessage={() => "No data found."}
                          maxMenuHeight={200}
                          asterisk={true}
                          isClearable={true}
                          customError={
                            (userRoleError && "Please select a user role.") ||
                            ""
                          }
                        />
                      </Col>

                      <Col style={{ marginTop: "28px", paddingBottom: "20px" }}>
                        <Button
                          onClick={handleGo}
                          color="primary"
                          type="button"
                          className="waves-effect waves-light me-1"
                          style={{ background: "#006eb9" }}
                        >
                          Go
                        </Button>
                      </Col>
                    </Row>

                    <Row
                      style={{
                        width: "100%",
                        overflowX: "auto",
                        overflowY: "auto",
                        maxHeight: "55vh",
                        width: "100%",
                        scrollBehavior: "smooth",
                        scrollbarWidth: "thin",
                        msOverflowStyle: "none",
                        zIndex: 0,
                      }}
                    >
                      <Col xl="12">
                        <table className="table table-bordered">
                          {/* <thead
                            style={{
                              backgroundColor: "#f9992d",
                              position: "sticky",
                              top: 0,
                              zIndex: 2,
                            }}
                          >
                            <tr>
                              <th style={{ width: "75%" }}>Menu Name</th>

                              <th style={{ width: "25%", textAlign: "center" }}>
                                <div className="d-flex justify-content-center align-items-center gap-2">
                                  <span>Select All</span>

                                  <CheckboxInput
                                    checked={isAllSelected}
                                    handleTextChange={(e) =>
                                      handleSelectAll(e.target.checked)
                                    }
                                    parentClassName="form-check"
                                    checkBoxClassName="form-check-input"
                                    labelStyle={{ display: "none" }}
                                    checkboxStyle={{
                                      width: "16px",
                                      height: "16px",
                                    }}
                                    disabled={loading}
                                  />
                                </div>
                              </th>
                            </tr>
                          </thead> */}
                          <thead
                            style={{
                              backgroundColor: "#f9992d",
                              position: "sticky",
                              top: 0,
                              backgroundColor: "#f9992d",
                              zIndex: 1,
                            }}
                          >
                            <tr>
                              <th>Menu Name</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {!loading && data.length > 0 && (
                              <tr
                                style={{
                                  backgroundColor: "#f8f9fa",
                                  fontWeight: "600",
                                }}
                              >
                                <td>Select All</td>
                                <td style={{ textAlign: "center" }}>
                                  <CheckboxInput
                                    checked={isAllSelected}
                                    handleTextChange={(e) =>
                                      handleSelectAll(e.target.checked)
                                    }
                                    parentClassName="form-check"
                                    checkBoxClassName="form-check-input"
                                    labelStyle={{ display: "none" }}
                                    checkboxStyle={{
                                      width: "16px",
                                      height: "16px",
                                    }}
                                  />
                                </td>
                              </tr>
                            )}
                            {loading ? (
                              <tr>
                                <td
                                  colSpan="2"
                                  style={{
                                    textAlign: "center",
                                    padding: "40px",
                                  }}
                                >
                                  <Spinner className="text-primary" />
                                </td>
                              </tr>
                            ) : data.length > 0 ? (
                              data
                                .filter((item) => item.parent_id === null)
                                .map((parent) => (
                                  <React.Fragment key={parent.id}>
                                    {/* PARENT ROW */}

                                    <tr>
                                      <td
                                        style={{
                                          cursor: "pointer",
                                          fontWeight: "bold",
                                        }}
                                        onClick={() =>
                                          handleToggleExpand(parent.id)
                                        }
                                      >
                                        {parent.isExpanded ? "▼" : "▶"}{" "}
                                        {parent.menu_name}
                                      </td>

                                      <td>
                                        <CheckboxInput
                                          checked={parent?.isChecked}
                                          indeterminate={parent.isIndeterminate}
                                          handleTextChange={(e) =>
                                            handleCheckboxChange(
                                              parent.id,
                                              e.target.checked
                                            )
                                          }
                                          parentClassName="form-check"
                                          checkBoxClassName="form-check-input"
                                          labelStyle={{ display: "none" }}
                                          checkboxStyle={{
                                            width: "16px",
                                            height: "16px",
                                          }}
                                        />
                                      </td>
                                    </tr>

                                    {/* CHILD ROWS */}
                                    {parent.isExpanded &&
                                      data
                                        .filter(
                                          (child) =>
                                            child.parent_id === parent.id
                                        )
                                        .map((child) => (
                                          <tr key={child.id}>
                                            <td style={{ paddingLeft: "20px" }}>
                                              ↳ {child.menu_name}
                                            </td>
                                            <td>
                                              <CheckboxInput
                                                checked={child?.isChecked}
                                                handleTextChange={(e) =>
                                                  handleCheckboxChange(
                                                    child.id,
                                                    e.target.checked
                                                  )
                                                }
                                                parentClassName="form-check"
                                                checkBoxClassName="form-check-input"
                                                labelStyle={{ display: "none" }}
                                                checkboxStyle={{
                                                  width: "16px",
                                                  height: "16px",
                                                }}
                                              />
                                            </td>
                                          </tr>
                                        ))}
                                  </React.Fragment>
                                ))
                            ) : (
                              <tr>
                                <td colSpan="2" style={{ textAlign: "center" }}>
                                  No menus found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </Col>
                    </Row>

                    {!loading && data.length > 0 && (
                      <Row className="mt-4 justify-content-center">
                        <Col
                          style={{
                            paddingTop: "10px",
                            borderTop: "1px solid #ced4da",
                            display: "flex",
                            justifyContent: "center",
                            textAlign: "center",
                          }}
                        >
                          <Button color="primary" onClick={handleSubmit}>
                            Submit
                          </Button>
                        </Col>
                      </Row>
                    )}
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserTypeAccess;
